import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconHome = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--home")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
          <path d="M5 23a3 3 0 0 1-3-3V9a1 1 0 0 1 .386-.79l9-7a1 1 0 0 1 1.228 0l9 7A1 1 0 0 1 22 9v11a3 3 0 0 1-3 3H5zm7-19.733L4 9.489V20a1 1 0 0 0 1 1h3v-9a1 1 0 0 1 .883-.993L9 11h6a1 1 0 0 1 1 1v9h3a1 1 0 0 0 1-1V9.49l-8-6.223zM14 13h-4v8h4v-8z" fill="currentColor"/>
      </g>
  </IconWrapper>
)
